import styled from 'styled-components';

export const ContentWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	gap: 20px;
`;

export const CenteredTable = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const ReasonCell = styled.td`
	vertical-align: top;
	padding: 8px;
`;

export const ReasonItem = styled.p`
	margin: 0 0 4px 0;
	padding: 4px 8px;
	background-color: #f3f4f6;
	border-radius: 4px;
	font-size: 0.85rem;
	color: #374151;
	border: 1px solid #e5e7eb;
	line-height: 1.4;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const ReasonRow = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 8px;
`;

export const CorrectionReasonsContainer = styled.div`
	margin: 20px 0;
	padding: 10px;
	border: 1px solid #eee;
`;

export const CorrectionReasonsLabel = styled.label`
	display: block;
	margin-bottom: 10px;
	font-weight: bold;
	color: #035072;
`;
